export const infoFullIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17"><path fill="#1058f5" d="M8 .5a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m.857 12a.857.857 0 0 1-1.714 0v-4a.857.857 0 0 1 1.714 0zM8 6.214a1.143 1.143 0 1 1 0-2.287 1.143 1.143 0 0 1 0 2.287"/></svg>`,
    name: 'info-full' as const
};